import React from 'react';
import './CTA.css';

const CTA = () => {
  return (
    <section className='cta-section'>
      <div className='cta-container'>

        <div className='cta-heading-container'>
          <p>Request Early Access to Get Started</p>
          <h3>Register Today & start exploring the endless possibilities.</h3>
        </div>

        <div className='cta-btn-container'>
          <button type="button" className='cta-btn'>Get Started</button>
        </div>

      </div>
    </section>
  )
}

export default CTA